// Function to calculate days until a given date
function calculateDaysUntilDate(targetDate) {
    // Get the current date
    const currentDate = new Date();
    
    // Convert the target date to a Date object
    const targetDateObj = new Date(targetDate);

    // Calculate the time difference in milliseconds
    const timeDifference = targetDateObj - currentDate;

    // Calculate the number of days
    const daysUntilDate = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    return daysUntilDate;
}

// Function to display the countdown
function displayCountdown() {
    // Define your target date in the format: "Month Day, Year"
    const targetDate = "DECEMBER 10, 2023";

    // Calculate the number of days until the target date
    const daysUntilTargetDate = calculateDaysUntilDate(targetDate);

    // Get the countdown element by its ID
    const countdownElement = document.getElementById("countdown");

    // Display the countdown in the specified element
    countdownElement.textContent = `${daysUntilTargetDate}`;
}

// Call the displayCountdown function when the page loads
window.onload = displayCountdown;
